/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskAttachment } from './TaskAttachment';
import {
    TaskAttachmentFromJSON,
    TaskAttachmentFromJSONTyped,
    TaskAttachmentToJSON,
    TaskAttachmentToJSONTyped,
} from './TaskAttachment';

/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    taskUid?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    assignee?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    resolution?: string;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    creationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Task
     */
    lastUpdate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    schema?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    customComponentName?: string;
    /**
     * 
     * @type {Array<TaskAttachment>}
     * @memberof Task
     */
    attachments?: Array<TaskAttachment>;
}

/**
 * Check if a given object implements the Task interface.
 */
export function instanceOfTask(value: object): value is Task {
    return true;
}

export function TaskFromJSON(json: any): Task {
    return TaskFromJSONTyped(json, false);
}

export function TaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): Task {
    if (json == null) {
        return json;
    }
    return {
        
        'taskUid': json['taskUid'] == null ? undefined : json['taskUid'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'assignee': json['assignee'] == null ? undefined : json['assignee'],
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
        'lastUpdate': json['lastUpdate'] == null ? undefined : (new Date(json['lastUpdate'])),
        'content': json['content'] == null ? undefined : json['content'],
        'schema': json['schema'] == null ? undefined : json['schema'],
        'customComponentName': json['customComponentName'] == null ? undefined : json['customComponentName'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(TaskAttachmentFromJSON)),
    };
}

export function TaskToJSON(json: any): Task {
    return TaskToJSONTyped(json, false);
}

export function TaskToJSONTyped(value?: Task | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskUid': value['taskUid'],
        'taskName': value['taskName'],
        'assignee': value['assignee'],
        'resolution': value['resolution'],
        'creationDate': value['creationDate'] == null ? value['creationDate'] : value['creationDate'].toISOString(),
        'lastUpdate': value['lastUpdate'] == null ? value['lastUpdate'] : value['lastUpdate'].toISOString(),
        'content': value['content'],
        'schema': value['schema'],
        'customComponentName': value['customComponentName'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(TaskAttachmentToJSON)),
    };
}

